<template>
  <div
    class="flex items-center justify-center font-semibold text-[32px] sm:text-[18px]"
  >
    <Resource
      class="w-[36px] h-[36px] sm:h-[24px] sm:w-[24px] mr-[4px]"
      :src="getFeUrl('/youyan-platform/png/ai-bling.png')"
      :transform-resource="transformImage"
    />
    <slot />
  </div>
</template>
